export default __webpack_public_path__ + "static/media/TB.b964a367.png";